import React from 'react';

import Rightplasti from './Rightplasti';
import Moldinghighli from './Moldinghighli';
import Machinesdpserie from './Machinesdpserie';
import Rightcpallet from './Rightcpallet';
import Rightpalltable from './Rightpalltable';

const Rightplasticpal = () => {
    return (
        <div>
            <Rightplasti />
            <Moldinghighli />
            <Machinesdpserie />
            <Rightcpallet />
            <Rightpalltable />
        </div>
    );
};

export default Rightplasticpal;
